/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useCallback } from 'react';
import ReactSelect, { components } from 'react-select';
import classNames from 'classnames';
import ConfirmationModal from '../modals/ConfirmationModal';
import ArrowIcon from '../../assets/images/keyboard_arrow_down.svg';

import './Select.scss';

// Custom Dropdown Indicator
const DropdownIndicator = (props) => (
	<components.DropdownIndicator {...props}>
		<img src={ArrowIcon} width={14} height={14} alt="dropdown indicator" />
	</components.DropdownIndicator>
);

const Select = (props) => {
	const [showConfirmation, setShowConfirmation] = useState(false);
	const [selected, setSelected] = useState(false);

	const getValue = () => {
		if (props.value && Array.isArray(props.options)) {
			if (props.isMulti) {
				return props.value.map((element) => ({ label: element, value: element }));
			}
			if (typeof props.value === 'object') {
				return props.options.find((option) => {
					return JSON.stringify(option.value) === JSON.stringify(props.value);
				});
			}
			return props.options.find((option) => {
				return option.value === props.value;
			});
		}
		if (props.nullOptionSelected) {
			return props.options.find((option) => option.value === null) || null;
		}
		return null;
	};

	const onSelect = (selectedOptions) => {
		let findSelected;
		if (!selectedOptions) {
			props.handleChange({ [props.name]: null }, props.additionalData);
			return;
		}
		if (props.isMulti) {
			findSelected = selectedOptions.map((option) => option.value);
		} else {
			findSelected = selectedOptions.value;
		}
		if (props.withConfirmation) {
			setSelected(findSelected);
			setShowConfirmation(true);
		} else {
			props.handleChange({ [props.name]: findSelected }, props.additionalData);
		}
	};

	const noOptionsMessage = useCallback(() => props.noOptionsMessage || 'No options', [props.noOptionsMessage]);

	return (
		<div className={classNames('select-container', props.containerClass)}>
			{props.label && <div className="select-label">{props.label}</div>}
			{props.readOnly ? (
				<div className="select__readonly">{getValue()?.label}</div>
			) : (
				<ReactSelect
					placeholder={props.placeholder}
					className={classNames(
						{ 'read-only': props.disabled, 'invalid-input': props.invalid, 'has-error': props.hasError },
						props.className
					)}
					classNamePrefix="sm"
					menuPlacement={props.menuPlacement || 'auto'}
					menuShouldScrollIntoView={false}
					isMulti={props.isMulti}
					isClearable={props.isClearable || false}
					isSearchable={props.isSearchable || false}
					noOptionsMessage={noOptionsMessage}
					value={getValue()}
					defaultValue={props.defaultValue}
					onChange={onSelect}
					options={props.options}
					components={{ DropdownIndicator, ...props.customComponents }}
					openMenuOnClick={props.openMenuOnClick}
					controlShouldRenderValue={props.controlShouldRenderValue}
					blurInputOnSelect
					isDisabled={props.isDisabled}
					filterOption={props.filterFn}
					formatOptionLabel={props.formatOptionLabel}
					menuPortalTarget={props.menuPortalTarget}
					menuPosition={props.menuPosition}
					styles={props.styles}
				/>
			)}

			{showConfirmation && (
				<ConfirmationModal
					onConfirm={() => {
						setShowConfirmation(false);
						props.handleChange({ [props.name]: selected }, props.additionalData);
					}}
					onCancel={() => setShowConfirmation(false)}
				>
					{props.confirmationMessage}
				</ConfirmationModal>
			)}
		</div>
	);
};

export default Select;
